const NOT_AUTHORIZED = 'NotAuthorizedException';
const INVALID_PASSWORD = 'InvalidPasswordException';
const CODE_MISMATCH = 'CodeMismatchException';
const SETUP_MFA = 'EnableSoftwareTokenMFAException';
const GENERAL = 'GENERAL';
const CHALLENGE_REQUIRED = 'CHALLENGE_REQUIRED';

// eslint-disable-next-line import/prefer-default-export
export const authErrors = {
  NOT_AUTHORIZED,
  INVALID_PASSWORD,
  CODE_MISMATCH,
  SETUP_MFA,
  CHALLENGE_REQUIRED,
  GENERAL,
};

export class AuthError extends Error {
  constructor(code, message) {
    super(message || code);
    this.code = code;
  }
}
